import { IconProps } from "./Icon.model";

export function LayoutListIcon({
  size = 16,
  fill = "currentColor",
}: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5.25C3 4.83579 3.33579 4.5 3.75 4.5H20.25C20.6642 4.5 21 4.83579 21 5.25V6.75C21 7.16421 20.6642 7.5 20.25 7.5H3.75C3.33579 7.5 3 7.16421 3 6.75V5.25ZM3 11.25C3 10.8358 3.33579 10.5 3.75 10.5H20.25C20.6642 10.5 21 10.8358 21 11.25V12.75C21 13.1642 20.6642 13.5 20.25 13.5H3.75C3.33579 13.5 3 13.1642 3 12.75V11.25ZM3 17.25C3 16.8358 3.33579 16.5 3.75 16.5H20.25C20.6642 16.5 21 16.8358 21 17.25V18.75C21 19.1642 20.6642 19.5 20.25 19.5H3.75C3.33579 19.5 3 19.1642 3 18.75V17.25Z"
        fill={fillColor}
      />
    </svg>
  );
}
